export * from './delete-berichts-vorlage.service';
export * from './delete-berichts-vorlage.service.module';